import { render } from "./OpportunityDetail.vue?vue&type=template&id=beccefe2&scoped=true"
import script from "./OpportunityDetail.vue?vue&type=script&lang=js"
export * from "./OpportunityDetail.vue?vue&type=script&lang=js"

import "./OpportunityDetail.vue?vue&type=style&index=0&id=beccefe2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-beccefe2"],['__file',"src/views/h5/crm/opportunity/OpportunityDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "beccefe2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('beccefe2', __exports__)) {
    api.reload('beccefe2', __exports__)
  }
  
  module.hot.accept("./OpportunityDetail.vue?vue&type=template&id=beccefe2&scoped=true", () => {
    api.rerender('beccefe2', render)
  })

}


export default __exports__